"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const emailVerificationStates_1 = require("./emailVerificationStates");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const _1 = require(".");
function default_1({ emailVerificationForm, sendVerificationEmail, resetEmailVerification, detectCapsLock, isSignUp, }) {
    const [isEmailUnique, setIsEmailUnique] = (0, recoil_1.useRecoilState)(emailVerificationStates_1.isEmailUniqueState);
    const [isEmailVerified, setIsEmailVerified] = (0, recoil_1.useRecoilState)(emailVerificationStates_1.isEmailVerifiedState);
    const checkEmailDuplication = (emailInput) => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.postData)('/api/v1/sign-up/duplication-check-email', { email: emailInput })
            .then(res => setIsEmailUnique(res.data.result.is_valid))
            .catch(error => (0, _1.handleEmailVerificationError)(error, emailVerificationForm.setError));
    });
    const duplicationTimerRef = (0, react_1.useRef)(0);
    const onEmailInputChange = (e) => {
        setIsEmailUnique(undefined);
        setIsEmailVerified(false);
        window.clearTimeout(duplicationTimerRef.current);
        const emailInput = e.currentTarget.value;
        if (detect_utils_1.emailRegex.test(emailInput)) {
            duplicationTimerRef.current = window.setTimeout(() => checkEmailDuplication(emailInput), 500);
        }
    };
    const isEmailReadyToVerify = isEmailUnique && !isEmailVerified;
    const sendVeriEmailOnEnter = (e) => {
        isEmailReadyToVerify && e.key === 'Enter' && sendVerificationEmail();
    };
    const isEmailAssigned = (0, recoil_1.useRecoilValue)(emailVerificationStates_1.isEmailAssignedState);
    const isEmailApproved = isEmailVerified === true;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(_1.EmailVerificationInputDiv, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({ autoComplete: isSignUp ? 'off' : 'email', type: "email", disabled: isEmailAssigned || isEmailApproved, placeholder: t('이메일') }, emailVerificationForm.register('email', {
                required: t('이메일을 입력해주세요'),
                pattern: { value: detect_utils_1.emailRegex, message: _1.emailVeriErrMsgObj.pattern() },
                onChange: isEmailAssigned ? undefined : onEmailInputChange,
            }), { onKeyDown: sendVeriEmailOnEnter, onKeyUp: detectCapsLock, style: { paddingRight: '64px' } })), isEmailReadyToVerify && ((0, jsx_runtime_1.jsx)(_1.BlackAuthButton, Object.assign({ onClick: sendVerificationEmail }, { children: t('인증') }))), isEmailApproved && ((0, jsx_runtime_1.jsx)(_1.ChangeEmailButton, Object.assign({ onClick: resetEmailVerification }, { children: t('변경') })))] }));
}
exports.default = default_1;
